import React, { useEffect, useState } from 'react';
import TagMoveButtons from './TagMoveButtons';
import TagDeleteButton from './TagDeleteButton';
import { Tag } from '../../../../../../../common/tags/tagTypes';
import { ImMNElement } from '../../../../../../../common/elements/elementModelTypes';
import { TagElementsRetrievalData } from '../../../../../../../common/api/tags/tagElementsRetrievalRouteTypes';
import TagRenameField from './TagRenameField';
import TagEditColorButton from './TagEditColorButton';
import { getElementsByTagId } from '../../../../../../element/tags/tagsService';

export type TagEditContentProps = {
    tag: Tag | null;
    shareRootPath: ImMNElement[];
    closePopup: () => void;
};

const TagEditContent: React.FC<TagEditContentProps> = (props) => {
    const { tag, closePopup } = props;
    if (!tag) return null;

    const [taggedElements, setTaggedElements] = useState<TagElementsRetrievalData[]>([]);

    useEffect(() => {
        const fetchTaggedElements = async () => {
            const tagElementData = await getElementsByTagId(tag.id);
            setTaggedElements(tagElementData);
        };

        fetchTaggedElements();
    }, [tag]);

    return (
        <div className="MobileTagEditContent">
            <TagMoveButtons {...props} taggedElements={taggedElements} />
            <TagDeleteButton {...props} taggedElements={taggedElements} />
            <TagRenameField tag={tag} closePopup={closePopup} />
            <TagEditColorButton tag={tag} />
        </div>
    );
};

export default TagEditContent;
